import {renderMarkdown} from "@/utils/markdownHandler";

export default class Reseller {
    constructor(obj, hasRowMarkdown = false) {
        this.id = obj.id;
        this.name = obj.Nome;
        this.title = obj.Titolo;
        this.contact = obj.Contatto;
        this.isContactEmail = !obj.Contatto.startsWith("+39");
        this.phone = obj.Telefono;
        this.email = obj.Email;
        this.address = obj.Indirizzo;
        this.city = obj.Citta;
        this.CAP = obj.CAP;
        this.province = obj.Provincia;
        this.activityCities = obj.ComuniAttivita;
        this.Lat = obj.Lat;
        this.Lon = obj.Lon;
        this.description = hasRowMarkdown ? renderMarkdown(obj.Descrizione) : obj.Descrizione;
        this.published_at = obj.published_at;
        this.created_at = obj.created_at;
        this.updated_at = obj.updated_at;
    }
}